import React, { useState } from 'react';
import { getCombinedMetricsData } from '../../common/helpers//MetricsHistoryHelper';
import MUIDataTable from 'mui-datatables';
import { format } from 'date-fns';
import "../../common/css/protagonistMUIDatatable.css";
import "../../common/css/icons.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { deleteMetric } from '../../common/api/PortcoMetricsAPIHelper';
import { Snackbar } from '@mui/material';

import './metricsHistory.css';

const MetricsHistory = ({ portcoId, metricCode }) => {
  const [data, setData] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const fetchData = async () => {
    const result = await getCombinedMetricsData(portcoId, metricCode);
    setData(result);
  };

  React.useEffect(() => {
    fetchData();
  }, []);
  
  const handleDelete = async (portcoMetricId) => {
    const confirmed = window.confirm('Are you sure you want to delete the metric?');
    if (confirmed) {
      const response = await deleteMetric(portcoMetricId);
      if (response === 200) {
        setSnackbarMessage(`Successfully deleted metric with ID ${portcoMetricId}`);
        fetchData();
      } else {
        setSnackbarMessage(`Failed to delete metric with ID ${portcoMetricId}`);
      }
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarMessage('');
  };

  const deleteIconRenderer = (value, tableMeta, updateValue) => {
    return (
      <div className="delete_column">
        <FontAwesomeIcon 
          icon={faTrashAlt} 
          className="ra__protMUIDatatable_icon" 
          onClick={() => handleDelete(value)}
        />
      </div>
    );
  };

  const customDateRender = (value, tableMeta, updateValue) => {
    const investmentDate = new Date(value);
    const localDate = new Date(investmentDate.getTime() - investmentDate.getTimezoneOffset() * 60000);
    return format(localDate, 'do MMM, yyyy');
  };

  const customValueRender = (value) => {
    return Number(value).toLocaleString();
  };

  const columns = [
    { 
      name: 'portco_metric_id', 
      label: 'Delete',
      options: {
        customBodyRender: deleteIconRenderer,
      }
    },
    { 
      name: 'metric_name', 
      label: 'Metric Name',
      options: {
        sort: true,
      }
    },
    { name: 'metric_date', label: 'Metric Date', 
      options: {
        sort: true,
        customBodyRender: customDateRender,
      }
    },
    { name: 'metric_value', label: 'Metric Value',
      options: {
        customBodyRender: customValueRender,
      } 
    },
  ];

  const options = {
    filter: false,
    filterType: 'dropdown',
    responsive: 'standard',
    serverSide: false,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15],
    selectableRows: 'none',
    expandableRows: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    customToolbarSelect: () => {},
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'medium',
      };
    },
    textLabels: {
      body: {
        noMatch: 'Sorry, no matching records found',
      },
    },
    sortOrder: {
      name: 'metric_date',
      direction: 'desc'
    }
  };

  return (
    <div className="mui-table-container">
      <MUIDataTable
        data={data}
        columns={columns}
        options={options}
        className="protMUIDatatable"
        style={{ width: '100%' }}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        className={snackbarMessage.includes('Successfully') ? 'metricsHistoryTable_snackbar' : 'metricsHistoryTable_snackbar error'}
      />
      </div>
  );
};

export default MetricsHistory;
